/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IIntraOPNursingRecord } from 'app/shared/model/intra-op-nursing-record.model';
import { CountType } from 'app/shared/model/enumerations/count-type.model';

export interface IIntraOPCount {
  id?: string;
  countType?: keyof typeof CountType | null;
  sponges?: number | null;
  gauze?: number | null;
  peanut?: number | null;
  cottonoid?: number | null;
  vesselLoop?: number | null;
  rollerGauze?: number | null;
  instrument?: number | null;
  needle?: number | null;
  active?: boolean;
  cursor?: number;
  lastupdated?: number;
  microSec?: number;
  timestampentry?: number;
  nursingRecord?: IIntraOPNursingRecord;
}

export const defaultValue: Readonly<IIntraOPCount> = {
  active: false,
};
